import Axios from "axios";
import {
    SET_LEAD_SOURCE_TYPES_LIST,
    UNSET_LEAD_SOURCE_TYPES_LIST,
} from "@/store/mutation-types";
import { saveUpdateSalesLeadsourceType, getSalesLeadTypes } from "@/store/api";
// initial state
const state = {
    getSalesLeadTypes: [],
    editingSalesLeadTypes: null,
};

const getters = {
    getSalesLeadTypes(state) {
        return state.getSalesLeadTypes;
    },
    getEditingSalesLeadTypes: (state) => state.editingSalesLeadTypes,
};

const mutations = {
    [SET_LEAD_SOURCE_TYPES_LIST](state, data) {
        state.getSalesLeadTypes = data;
    },
    [UNSET_LEAD_SOURCE_TYPES_LIST](state) {
        state.getSalesLeadTypes = [];
    },
    setEditingSalesLeadTypes(state, lead) {
        state.editingSalesLeadTypes = lead;
    },
};

const actions = {
    saveUpdateSalesLeadsourceType({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesLeadsourceType, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesLeadTypes({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadTypes, data)
                .then(function (response) {
                    commit("SET_LEAD_SOURCE_TYPES_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_LEAD_SOURCE_TYPES_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },

    getSalesLeadTypesById({ commit }, data) {
        const getSalesLeadTypesById = `${getSalesLeadTypes}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadTypesById)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getGeneratedSalesLeadsCode({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(generateSalesLeadsCode)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
